import { default as index67OXUxKaOzMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/aboutUs/index.vue?macro=true";
import { default as index8Gp5bopzu3Meta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/addPassenger/index.vue?macro=true";
import { default as index6HhfP7c1vAMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/commonProblem/index.vue?macro=true";
import { default as indexN32QwjWSRpMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/confirmation/index.vue?macro=true";
import { default as indexAKeb4oRIn9Meta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/contactUs/index.vue?macro=true";
import { default as indexZIEK4fMImpMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/faqDetail/index.vue?macro=true";
import { default as indexvVegsFSbnkMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/fareRule/index.vue?macro=true";
import { default as indexgu2YhObMNhMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightDetail/index.vue?macro=true";
import { default as indexTGukS2v6iVMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightLoading/index.vue?macro=true";
import { default as _91toCity_93fHbECYaPeKMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flights/search/[fromCity]/[toCity].vue?macro=true";
import { default as _91id_93JqGXi02U1zMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/iframePage/[id].vue?macro=true";
import { default as indextBH70dRPvEMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/index.vue?macro=true";
import { default as indexGrGE5q2MIWMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myAccount/index.vue?macro=true";
import { default as index0E9IupIs92Meta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myBooking/index.vue?macro=true";
import { default as indexBGNpzx1Cu3Meta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderComplete/index.vue?macro=true";
import { default as _91id_93uhvInreOjbMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderDetail/[id].vue?macro=true";
import { default as indexJFA7QvLABQMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payComplete/index.vue?macro=true";
import { default as index5sQA2x4E0wMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payforPage/index.vue?macro=true";
import { default as indexxMkMPQWVM4Meta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payments/index.vue?macro=true";
import { default as _91id_938gu28suH50Meta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/receiptPage/[id].vue?macro=true";
import { default as indexWQpFMaQ6FeMeta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/searchLoading/index.vue?macro=true";
import { default as indexyk1AWCZTP7Meta } from "/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/skeleton/index.vue?macro=true";
export default [
  {
    name: index67OXUxKaOzMeta?.name ?? "aboutUs___En",
    path: index67OXUxKaOzMeta?.path ?? "/En/aboutUs",
    meta: index67OXUxKaOzMeta || {},
    alias: index67OXUxKaOzMeta?.alias || [],
    redirect: index67OXUxKaOzMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: index67OXUxKaOzMeta?.name ?? "aboutUs___Hk",
    path: index67OXUxKaOzMeta?.path ?? "/Hk/aboutUs",
    meta: index67OXUxKaOzMeta || {},
    alias: index67OXUxKaOzMeta?.alias || [],
    redirect: index67OXUxKaOzMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: index67OXUxKaOzMeta?.name ?? "aboutUs___Cn",
    path: index67OXUxKaOzMeta?.path ?? "/Cn/aboutUs",
    meta: index67OXUxKaOzMeta || {},
    alias: index67OXUxKaOzMeta?.alias || [],
    redirect: index67OXUxKaOzMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: index67OXUxKaOzMeta?.name ?? "aboutUs___Id",
    path: index67OXUxKaOzMeta?.path ?? "/Id/aboutUs",
    meta: index67OXUxKaOzMeta || {},
    alias: index67OXUxKaOzMeta?.alias || [],
    redirect: index67OXUxKaOzMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: index67OXUxKaOzMeta?.name ?? "aboutUs___Ja",
    path: index67OXUxKaOzMeta?.path ?? "/Ja/aboutUs",
    meta: index67OXUxKaOzMeta || {},
    alias: index67OXUxKaOzMeta?.alias || [],
    redirect: index67OXUxKaOzMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/aboutUs/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gp5bopzu3Meta?.name ?? "addPassenger___En",
    path: index8Gp5bopzu3Meta?.path ?? "/En/addPassenger",
    meta: index8Gp5bopzu3Meta || {},
    alias: index8Gp5bopzu3Meta?.alias || [],
    redirect: index8Gp5bopzu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gp5bopzu3Meta?.name ?? "addPassenger___Hk",
    path: index8Gp5bopzu3Meta?.path ?? "/Hk/addPassenger",
    meta: index8Gp5bopzu3Meta || {},
    alias: index8Gp5bopzu3Meta?.alias || [],
    redirect: index8Gp5bopzu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gp5bopzu3Meta?.name ?? "addPassenger___Cn",
    path: index8Gp5bopzu3Meta?.path ?? "/Cn/addPassenger",
    meta: index8Gp5bopzu3Meta || {},
    alias: index8Gp5bopzu3Meta?.alias || [],
    redirect: index8Gp5bopzu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gp5bopzu3Meta?.name ?? "addPassenger___Id",
    path: index8Gp5bopzu3Meta?.path ?? "/Id/addPassenger",
    meta: index8Gp5bopzu3Meta || {},
    alias: index8Gp5bopzu3Meta?.alias || [],
    redirect: index8Gp5bopzu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: index8Gp5bopzu3Meta?.name ?? "addPassenger___Ja",
    path: index8Gp5bopzu3Meta?.path ?? "/Ja/addPassenger",
    meta: index8Gp5bopzu3Meta || {},
    alias: index8Gp5bopzu3Meta?.alias || [],
    redirect: index8Gp5bopzu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/addPassenger/index.vue").then(m => m.default || m)
  },
  {
    name: index6HhfP7c1vAMeta?.name ?? "commonProblem___En",
    path: index6HhfP7c1vAMeta?.path ?? "/En/commonProblem",
    meta: index6HhfP7c1vAMeta || {},
    alias: index6HhfP7c1vAMeta?.alias || [],
    redirect: index6HhfP7c1vAMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/commonProblem/index.vue").then(m => m.default || m)
  },
  {
    name: index6HhfP7c1vAMeta?.name ?? "commonProblem___Hk",
    path: index6HhfP7c1vAMeta?.path ?? "/Hk/commonProblem",
    meta: index6HhfP7c1vAMeta || {},
    alias: index6HhfP7c1vAMeta?.alias || [],
    redirect: index6HhfP7c1vAMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/commonProblem/index.vue").then(m => m.default || m)
  },
  {
    name: index6HhfP7c1vAMeta?.name ?? "commonProblem___Cn",
    path: index6HhfP7c1vAMeta?.path ?? "/Cn/commonProblem",
    meta: index6HhfP7c1vAMeta || {},
    alias: index6HhfP7c1vAMeta?.alias || [],
    redirect: index6HhfP7c1vAMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/commonProblem/index.vue").then(m => m.default || m)
  },
  {
    name: index6HhfP7c1vAMeta?.name ?? "commonProblem___Id",
    path: index6HhfP7c1vAMeta?.path ?? "/Id/commonProblem",
    meta: index6HhfP7c1vAMeta || {},
    alias: index6HhfP7c1vAMeta?.alias || [],
    redirect: index6HhfP7c1vAMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/commonProblem/index.vue").then(m => m.default || m)
  },
  {
    name: index6HhfP7c1vAMeta?.name ?? "commonProblem___Ja",
    path: index6HhfP7c1vAMeta?.path ?? "/Ja/commonProblem",
    meta: index6HhfP7c1vAMeta || {},
    alias: index6HhfP7c1vAMeta?.alias || [],
    redirect: index6HhfP7c1vAMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/commonProblem/index.vue").then(m => m.default || m)
  },
  {
    name: indexN32QwjWSRpMeta?.name ?? "confirmation___En",
    path: indexN32QwjWSRpMeta?.path ?? "/En/confirmation",
    meta: indexN32QwjWSRpMeta || {},
    alias: indexN32QwjWSRpMeta?.alias || [],
    redirect: indexN32QwjWSRpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: indexN32QwjWSRpMeta?.name ?? "confirmation___Hk",
    path: indexN32QwjWSRpMeta?.path ?? "/Hk/confirmation",
    meta: indexN32QwjWSRpMeta || {},
    alias: indexN32QwjWSRpMeta?.alias || [],
    redirect: indexN32QwjWSRpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: indexN32QwjWSRpMeta?.name ?? "confirmation___Cn",
    path: indexN32QwjWSRpMeta?.path ?? "/Cn/confirmation",
    meta: indexN32QwjWSRpMeta || {},
    alias: indexN32QwjWSRpMeta?.alias || [],
    redirect: indexN32QwjWSRpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: indexN32QwjWSRpMeta?.name ?? "confirmation___Id",
    path: indexN32QwjWSRpMeta?.path ?? "/Id/confirmation",
    meta: indexN32QwjWSRpMeta || {},
    alias: indexN32QwjWSRpMeta?.alias || [],
    redirect: indexN32QwjWSRpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: indexN32QwjWSRpMeta?.name ?? "confirmation___Ja",
    path: indexN32QwjWSRpMeta?.path ?? "/Ja/confirmation",
    meta: indexN32QwjWSRpMeta || {},
    alias: indexN32QwjWSRpMeta?.alias || [],
    redirect: indexN32QwjWSRpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/confirmation/index.vue").then(m => m.default || m)
  },
  {
    name: indexAKeb4oRIn9Meta?.name ?? "contactUs___En",
    path: indexAKeb4oRIn9Meta?.path ?? "/En/contactUs",
    meta: indexAKeb4oRIn9Meta || {},
    alias: indexAKeb4oRIn9Meta?.alias || [],
    redirect: indexAKeb4oRIn9Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: indexAKeb4oRIn9Meta?.name ?? "contactUs___Hk",
    path: indexAKeb4oRIn9Meta?.path ?? "/Hk/contactUs",
    meta: indexAKeb4oRIn9Meta || {},
    alias: indexAKeb4oRIn9Meta?.alias || [],
    redirect: indexAKeb4oRIn9Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: indexAKeb4oRIn9Meta?.name ?? "contactUs___Cn",
    path: indexAKeb4oRIn9Meta?.path ?? "/Cn/contactUs",
    meta: indexAKeb4oRIn9Meta || {},
    alias: indexAKeb4oRIn9Meta?.alias || [],
    redirect: indexAKeb4oRIn9Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: indexAKeb4oRIn9Meta?.name ?? "contactUs___Id",
    path: indexAKeb4oRIn9Meta?.path ?? "/Id/contactUs",
    meta: indexAKeb4oRIn9Meta || {},
    alias: indexAKeb4oRIn9Meta?.alias || [],
    redirect: indexAKeb4oRIn9Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: indexAKeb4oRIn9Meta?.name ?? "contactUs___Ja",
    path: indexAKeb4oRIn9Meta?.path ?? "/Ja/contactUs",
    meta: indexAKeb4oRIn9Meta || {},
    alias: indexAKeb4oRIn9Meta?.alias || [],
    redirect: indexAKeb4oRIn9Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/contactUs/index.vue").then(m => m.default || m)
  },
  {
    name: indexZIEK4fMImpMeta?.name ?? "faqDetail___En",
    path: indexZIEK4fMImpMeta?.path ?? "/En/faqDetail",
    meta: indexZIEK4fMImpMeta || {},
    alias: indexZIEK4fMImpMeta?.alias || [],
    redirect: indexZIEK4fMImpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/faqDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexZIEK4fMImpMeta?.name ?? "faqDetail___Hk",
    path: indexZIEK4fMImpMeta?.path ?? "/Hk/faqDetail",
    meta: indexZIEK4fMImpMeta || {},
    alias: indexZIEK4fMImpMeta?.alias || [],
    redirect: indexZIEK4fMImpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/faqDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexZIEK4fMImpMeta?.name ?? "faqDetail___Cn",
    path: indexZIEK4fMImpMeta?.path ?? "/Cn/faqDetail",
    meta: indexZIEK4fMImpMeta || {},
    alias: indexZIEK4fMImpMeta?.alias || [],
    redirect: indexZIEK4fMImpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/faqDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexZIEK4fMImpMeta?.name ?? "faqDetail___Id",
    path: indexZIEK4fMImpMeta?.path ?? "/Id/faqDetail",
    meta: indexZIEK4fMImpMeta || {},
    alias: indexZIEK4fMImpMeta?.alias || [],
    redirect: indexZIEK4fMImpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/faqDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexZIEK4fMImpMeta?.name ?? "faqDetail___Ja",
    path: indexZIEK4fMImpMeta?.path ?? "/Ja/faqDetail",
    meta: indexZIEK4fMImpMeta || {},
    alias: indexZIEK4fMImpMeta?.alias || [],
    redirect: indexZIEK4fMImpMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/faqDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexvVegsFSbnkMeta?.name ?? "fareRule___En",
    path: indexvVegsFSbnkMeta?.path ?? "/En/fareRule",
    meta: indexvVegsFSbnkMeta || {},
    alias: indexvVegsFSbnkMeta?.alias || [],
    redirect: indexvVegsFSbnkMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/fareRule/index.vue").then(m => m.default || m)
  },
  {
    name: indexvVegsFSbnkMeta?.name ?? "fareRule___Hk",
    path: indexvVegsFSbnkMeta?.path ?? "/Hk/fareRule",
    meta: indexvVegsFSbnkMeta || {},
    alias: indexvVegsFSbnkMeta?.alias || [],
    redirect: indexvVegsFSbnkMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/fareRule/index.vue").then(m => m.default || m)
  },
  {
    name: indexvVegsFSbnkMeta?.name ?? "fareRule___Cn",
    path: indexvVegsFSbnkMeta?.path ?? "/Cn/fareRule",
    meta: indexvVegsFSbnkMeta || {},
    alias: indexvVegsFSbnkMeta?.alias || [],
    redirect: indexvVegsFSbnkMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/fareRule/index.vue").then(m => m.default || m)
  },
  {
    name: indexvVegsFSbnkMeta?.name ?? "fareRule___Id",
    path: indexvVegsFSbnkMeta?.path ?? "/Id/fareRule",
    meta: indexvVegsFSbnkMeta || {},
    alias: indexvVegsFSbnkMeta?.alias || [],
    redirect: indexvVegsFSbnkMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/fareRule/index.vue").then(m => m.default || m)
  },
  {
    name: indexvVegsFSbnkMeta?.name ?? "fareRule___Ja",
    path: indexvVegsFSbnkMeta?.path ?? "/Ja/fareRule",
    meta: indexvVegsFSbnkMeta || {},
    alias: indexvVegsFSbnkMeta?.alias || [],
    redirect: indexvVegsFSbnkMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/fareRule/index.vue").then(m => m.default || m)
  },
  {
    name: indexgu2YhObMNhMeta?.name ?? "flightDetail___En",
    path: indexgu2YhObMNhMeta?.path ?? "/En/flightDetail",
    meta: indexgu2YhObMNhMeta || {},
    alias: indexgu2YhObMNhMeta?.alias || [],
    redirect: indexgu2YhObMNhMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexgu2YhObMNhMeta?.name ?? "flightDetail___Hk",
    path: indexgu2YhObMNhMeta?.path ?? "/Hk/flightDetail",
    meta: indexgu2YhObMNhMeta || {},
    alias: indexgu2YhObMNhMeta?.alias || [],
    redirect: indexgu2YhObMNhMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexgu2YhObMNhMeta?.name ?? "flightDetail___Cn",
    path: indexgu2YhObMNhMeta?.path ?? "/Cn/flightDetail",
    meta: indexgu2YhObMNhMeta || {},
    alias: indexgu2YhObMNhMeta?.alias || [],
    redirect: indexgu2YhObMNhMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexgu2YhObMNhMeta?.name ?? "flightDetail___Id",
    path: indexgu2YhObMNhMeta?.path ?? "/Id/flightDetail",
    meta: indexgu2YhObMNhMeta || {},
    alias: indexgu2YhObMNhMeta?.alias || [],
    redirect: indexgu2YhObMNhMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexgu2YhObMNhMeta?.name ?? "flightDetail___Ja",
    path: indexgu2YhObMNhMeta?.path ?? "/Ja/flightDetail",
    meta: indexgu2YhObMNhMeta || {},
    alias: indexgu2YhObMNhMeta?.alias || [],
    redirect: indexgu2YhObMNhMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightDetail/index.vue").then(m => m.default || m)
  },
  {
    name: indexTGukS2v6iVMeta?.name ?? "flightLoading___En",
    path: indexTGukS2v6iVMeta?.path ?? "/En/flightLoading",
    meta: indexTGukS2v6iVMeta || {},
    alias: indexTGukS2v6iVMeta?.alias || [],
    redirect: indexTGukS2v6iVMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexTGukS2v6iVMeta?.name ?? "flightLoading___Hk",
    path: indexTGukS2v6iVMeta?.path ?? "/Hk/flightLoading",
    meta: indexTGukS2v6iVMeta || {},
    alias: indexTGukS2v6iVMeta?.alias || [],
    redirect: indexTGukS2v6iVMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexTGukS2v6iVMeta?.name ?? "flightLoading___Cn",
    path: indexTGukS2v6iVMeta?.path ?? "/Cn/flightLoading",
    meta: indexTGukS2v6iVMeta || {},
    alias: indexTGukS2v6iVMeta?.alias || [],
    redirect: indexTGukS2v6iVMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexTGukS2v6iVMeta?.name ?? "flightLoading___Id",
    path: indexTGukS2v6iVMeta?.path ?? "/Id/flightLoading",
    meta: indexTGukS2v6iVMeta || {},
    alias: indexTGukS2v6iVMeta?.alias || [],
    redirect: indexTGukS2v6iVMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexTGukS2v6iVMeta?.name ?? "flightLoading___Ja",
    path: indexTGukS2v6iVMeta?.path ?? "/Ja/flightLoading",
    meta: indexTGukS2v6iVMeta || {},
    alias: indexTGukS2v6iVMeta?.alias || [],
    redirect: indexTGukS2v6iVMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flightLoading/index.vue").then(m => m.default || m)
  },
  {
    name: _91toCity_93fHbECYaPeKMeta?.name ?? "flights-search-fromCity-toCity___En",
    path: _91toCity_93fHbECYaPeKMeta?.path ?? "/En/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93fHbECYaPeKMeta || {},
    alias: _91toCity_93fHbECYaPeKMeta?.alias || [],
    redirect: _91toCity_93fHbECYaPeKMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: _91toCity_93fHbECYaPeKMeta?.name ?? "flights-search-fromCity-toCity___Hk",
    path: _91toCity_93fHbECYaPeKMeta?.path ?? "/Hk/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93fHbECYaPeKMeta || {},
    alias: _91toCity_93fHbECYaPeKMeta?.alias || [],
    redirect: _91toCity_93fHbECYaPeKMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: _91toCity_93fHbECYaPeKMeta?.name ?? "flights-search-fromCity-toCity___Cn",
    path: _91toCity_93fHbECYaPeKMeta?.path ?? "/Cn/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93fHbECYaPeKMeta || {},
    alias: _91toCity_93fHbECYaPeKMeta?.alias || [],
    redirect: _91toCity_93fHbECYaPeKMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: _91toCity_93fHbECYaPeKMeta?.name ?? "flights-search-fromCity-toCity___Id",
    path: _91toCity_93fHbECYaPeKMeta?.path ?? "/Id/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93fHbECYaPeKMeta || {},
    alias: _91toCity_93fHbECYaPeKMeta?.alias || [],
    redirect: _91toCity_93fHbECYaPeKMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: _91toCity_93fHbECYaPeKMeta?.name ?? "flights-search-fromCity-toCity___Ja",
    path: _91toCity_93fHbECYaPeKMeta?.path ?? "/Ja/flights/search/:fromCity()/:toCity()",
    meta: _91toCity_93fHbECYaPeKMeta || {},
    alias: _91toCity_93fHbECYaPeKMeta?.alias || [],
    redirect: _91toCity_93fHbECYaPeKMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/flights/search/[fromCity]/[toCity].vue").then(m => m.default || m)
  },
  {
    name: _91id_93JqGXi02U1zMeta?.name ?? "iframePage-id___En",
    path: _91id_93JqGXi02U1zMeta?.path ?? "/En/iframePage/:id()",
    meta: _91id_93JqGXi02U1zMeta || {},
    alias: _91id_93JqGXi02U1zMeta?.alias || [],
    redirect: _91id_93JqGXi02U1zMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/iframePage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93JqGXi02U1zMeta?.name ?? "iframePage-id___Hk",
    path: _91id_93JqGXi02U1zMeta?.path ?? "/Hk/iframePage/:id()",
    meta: _91id_93JqGXi02U1zMeta || {},
    alias: _91id_93JqGXi02U1zMeta?.alias || [],
    redirect: _91id_93JqGXi02U1zMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/iframePage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93JqGXi02U1zMeta?.name ?? "iframePage-id___Cn",
    path: _91id_93JqGXi02U1zMeta?.path ?? "/Cn/iframePage/:id()",
    meta: _91id_93JqGXi02U1zMeta || {},
    alias: _91id_93JqGXi02U1zMeta?.alias || [],
    redirect: _91id_93JqGXi02U1zMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/iframePage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93JqGXi02U1zMeta?.name ?? "iframePage-id___Id",
    path: _91id_93JqGXi02U1zMeta?.path ?? "/Id/iframePage/:id()",
    meta: _91id_93JqGXi02U1zMeta || {},
    alias: _91id_93JqGXi02U1zMeta?.alias || [],
    redirect: _91id_93JqGXi02U1zMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/iframePage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93JqGXi02U1zMeta?.name ?? "iframePage-id___Ja",
    path: _91id_93JqGXi02U1zMeta?.path ?? "/Ja/iframePage/:id()",
    meta: _91id_93JqGXi02U1zMeta || {},
    alias: _91id_93JqGXi02U1zMeta?.alias || [],
    redirect: _91id_93JqGXi02U1zMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/iframePage/[id].vue").then(m => m.default || m)
  },
  {
    name: indextBH70dRPvEMeta?.name ?? "index___En",
    path: indextBH70dRPvEMeta?.path ?? "/En",
    meta: indextBH70dRPvEMeta || {},
    alias: indextBH70dRPvEMeta?.alias || [],
    redirect: indextBH70dRPvEMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indextBH70dRPvEMeta?.name ?? "index___Hk",
    path: indextBH70dRPvEMeta?.path ?? "/Hk",
    meta: indextBH70dRPvEMeta || {},
    alias: indextBH70dRPvEMeta?.alias || [],
    redirect: indextBH70dRPvEMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indextBH70dRPvEMeta?.name ?? "index___Cn",
    path: indextBH70dRPvEMeta?.path ?? "/Cn",
    meta: indextBH70dRPvEMeta || {},
    alias: indextBH70dRPvEMeta?.alias || [],
    redirect: indextBH70dRPvEMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indextBH70dRPvEMeta?.name ?? "index___Id",
    path: indextBH70dRPvEMeta?.path ?? "/Id",
    meta: indextBH70dRPvEMeta || {},
    alias: indextBH70dRPvEMeta?.alias || [],
    redirect: indextBH70dRPvEMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indextBH70dRPvEMeta?.name ?? "index___Ja",
    path: indextBH70dRPvEMeta?.path ?? "/Ja",
    meta: indextBH70dRPvEMeta || {},
    alias: indextBH70dRPvEMeta?.alias || [],
    redirect: indextBH70dRPvEMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrGE5q2MIWMeta?.name ?? "myAccount___En",
    path: indexGrGE5q2MIWMeta?.path ?? "/En/myAccount",
    meta: indexGrGE5q2MIWMeta || {},
    alias: indexGrGE5q2MIWMeta?.alias || [],
    redirect: indexGrGE5q2MIWMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myAccount/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrGE5q2MIWMeta?.name ?? "myAccount___Hk",
    path: indexGrGE5q2MIWMeta?.path ?? "/Hk/myAccount",
    meta: indexGrGE5q2MIWMeta || {},
    alias: indexGrGE5q2MIWMeta?.alias || [],
    redirect: indexGrGE5q2MIWMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myAccount/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrGE5q2MIWMeta?.name ?? "myAccount___Cn",
    path: indexGrGE5q2MIWMeta?.path ?? "/Cn/myAccount",
    meta: indexGrGE5q2MIWMeta || {},
    alias: indexGrGE5q2MIWMeta?.alias || [],
    redirect: indexGrGE5q2MIWMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myAccount/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrGE5q2MIWMeta?.name ?? "myAccount___Id",
    path: indexGrGE5q2MIWMeta?.path ?? "/Id/myAccount",
    meta: indexGrGE5q2MIWMeta || {},
    alias: indexGrGE5q2MIWMeta?.alias || [],
    redirect: indexGrGE5q2MIWMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myAccount/index.vue").then(m => m.default || m)
  },
  {
    name: indexGrGE5q2MIWMeta?.name ?? "myAccount___Ja",
    path: indexGrGE5q2MIWMeta?.path ?? "/Ja/myAccount",
    meta: indexGrGE5q2MIWMeta || {},
    alias: indexGrGE5q2MIWMeta?.alias || [],
    redirect: indexGrGE5q2MIWMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myAccount/index.vue").then(m => m.default || m)
  },
  {
    name: index0E9IupIs92Meta?.name ?? "myBooking___En",
    path: index0E9IupIs92Meta?.path ?? "/En/myBooking",
    meta: index0E9IupIs92Meta || {},
    alias: index0E9IupIs92Meta?.alias || [],
    redirect: index0E9IupIs92Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myBooking/index.vue").then(m => m.default || m)
  },
  {
    name: index0E9IupIs92Meta?.name ?? "myBooking___Hk",
    path: index0E9IupIs92Meta?.path ?? "/Hk/myBooking",
    meta: index0E9IupIs92Meta || {},
    alias: index0E9IupIs92Meta?.alias || [],
    redirect: index0E9IupIs92Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myBooking/index.vue").then(m => m.default || m)
  },
  {
    name: index0E9IupIs92Meta?.name ?? "myBooking___Cn",
    path: index0E9IupIs92Meta?.path ?? "/Cn/myBooking",
    meta: index0E9IupIs92Meta || {},
    alias: index0E9IupIs92Meta?.alias || [],
    redirect: index0E9IupIs92Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myBooking/index.vue").then(m => m.default || m)
  },
  {
    name: index0E9IupIs92Meta?.name ?? "myBooking___Id",
    path: index0E9IupIs92Meta?.path ?? "/Id/myBooking",
    meta: index0E9IupIs92Meta || {},
    alias: index0E9IupIs92Meta?.alias || [],
    redirect: index0E9IupIs92Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myBooking/index.vue").then(m => m.default || m)
  },
  {
    name: index0E9IupIs92Meta?.name ?? "myBooking___Ja",
    path: index0E9IupIs92Meta?.path ?? "/Ja/myBooking",
    meta: index0E9IupIs92Meta || {},
    alias: index0E9IupIs92Meta?.alias || [],
    redirect: index0E9IupIs92Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/myBooking/index.vue").then(m => m.default || m)
  },
  {
    name: indexBGNpzx1Cu3Meta?.name ?? "orderComplete___En",
    path: indexBGNpzx1Cu3Meta?.path ?? "/En/orderComplete",
    meta: indexBGNpzx1Cu3Meta || {},
    alias: indexBGNpzx1Cu3Meta?.alias || [],
    redirect: indexBGNpzx1Cu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexBGNpzx1Cu3Meta?.name ?? "orderComplete___Hk",
    path: indexBGNpzx1Cu3Meta?.path ?? "/Hk/orderComplete",
    meta: indexBGNpzx1Cu3Meta || {},
    alias: indexBGNpzx1Cu3Meta?.alias || [],
    redirect: indexBGNpzx1Cu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexBGNpzx1Cu3Meta?.name ?? "orderComplete___Cn",
    path: indexBGNpzx1Cu3Meta?.path ?? "/Cn/orderComplete",
    meta: indexBGNpzx1Cu3Meta || {},
    alias: indexBGNpzx1Cu3Meta?.alias || [],
    redirect: indexBGNpzx1Cu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexBGNpzx1Cu3Meta?.name ?? "orderComplete___Id",
    path: indexBGNpzx1Cu3Meta?.path ?? "/Id/orderComplete",
    meta: indexBGNpzx1Cu3Meta || {},
    alias: indexBGNpzx1Cu3Meta?.alias || [],
    redirect: indexBGNpzx1Cu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexBGNpzx1Cu3Meta?.name ?? "orderComplete___Ja",
    path: indexBGNpzx1Cu3Meta?.path ?? "/Ja/orderComplete",
    meta: indexBGNpzx1Cu3Meta || {},
    alias: indexBGNpzx1Cu3Meta?.alias || [],
    redirect: indexBGNpzx1Cu3Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderComplete/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93uhvInreOjbMeta?.name ?? "orderDetail-id___En",
    path: _91id_93uhvInreOjbMeta?.path ?? "/En/orderDetail/:id()",
    meta: _91id_93uhvInreOjbMeta || {},
    alias: _91id_93uhvInreOjbMeta?.alias || [],
    redirect: _91id_93uhvInreOjbMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93uhvInreOjbMeta?.name ?? "orderDetail-id___Hk",
    path: _91id_93uhvInreOjbMeta?.path ?? "/Hk/orderDetail/:id()",
    meta: _91id_93uhvInreOjbMeta || {},
    alias: _91id_93uhvInreOjbMeta?.alias || [],
    redirect: _91id_93uhvInreOjbMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93uhvInreOjbMeta?.name ?? "orderDetail-id___Cn",
    path: _91id_93uhvInreOjbMeta?.path ?? "/Cn/orderDetail/:id()",
    meta: _91id_93uhvInreOjbMeta || {},
    alias: _91id_93uhvInreOjbMeta?.alias || [],
    redirect: _91id_93uhvInreOjbMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93uhvInreOjbMeta?.name ?? "orderDetail-id___Id",
    path: _91id_93uhvInreOjbMeta?.path ?? "/Id/orderDetail/:id()",
    meta: _91id_93uhvInreOjbMeta || {},
    alias: _91id_93uhvInreOjbMeta?.alias || [],
    redirect: _91id_93uhvInreOjbMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93uhvInreOjbMeta?.name ?? "orderDetail-id___Ja",
    path: _91id_93uhvInreOjbMeta?.path ?? "/Ja/orderDetail/:id()",
    meta: _91id_93uhvInreOjbMeta || {},
    alias: _91id_93uhvInreOjbMeta?.alias || [],
    redirect: _91id_93uhvInreOjbMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/orderDetail/[id].vue").then(m => m.default || m)
  },
  {
    name: indexJFA7QvLABQMeta?.name ?? "payComplete___En",
    path: indexJFA7QvLABQMeta?.path ?? "/En/payComplete",
    meta: indexJFA7QvLABQMeta || {},
    alias: indexJFA7QvLABQMeta?.alias || [],
    redirect: indexJFA7QvLABQMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexJFA7QvLABQMeta?.name ?? "payComplete___Hk",
    path: indexJFA7QvLABQMeta?.path ?? "/Hk/payComplete",
    meta: indexJFA7QvLABQMeta || {},
    alias: indexJFA7QvLABQMeta?.alias || [],
    redirect: indexJFA7QvLABQMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexJFA7QvLABQMeta?.name ?? "payComplete___Cn",
    path: indexJFA7QvLABQMeta?.path ?? "/Cn/payComplete",
    meta: indexJFA7QvLABQMeta || {},
    alias: indexJFA7QvLABQMeta?.alias || [],
    redirect: indexJFA7QvLABQMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexJFA7QvLABQMeta?.name ?? "payComplete___Id",
    path: indexJFA7QvLABQMeta?.path ?? "/Id/payComplete",
    meta: indexJFA7QvLABQMeta || {},
    alias: indexJFA7QvLABQMeta?.alias || [],
    redirect: indexJFA7QvLABQMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: indexJFA7QvLABQMeta?.name ?? "payComplete___Ja",
    path: indexJFA7QvLABQMeta?.path ?? "/Ja/payComplete",
    meta: indexJFA7QvLABQMeta || {},
    alias: indexJFA7QvLABQMeta?.alias || [],
    redirect: indexJFA7QvLABQMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payComplete/index.vue").then(m => m.default || m)
  },
  {
    name: index5sQA2x4E0wMeta?.name ?? "payforPage___En",
    path: index5sQA2x4E0wMeta?.path ?? "/En/payforPage",
    meta: index5sQA2x4E0wMeta || {},
    alias: index5sQA2x4E0wMeta?.alias || [],
    redirect: index5sQA2x4E0wMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payforPage/index.vue").then(m => m.default || m)
  },
  {
    name: index5sQA2x4E0wMeta?.name ?? "payforPage___Hk",
    path: index5sQA2x4E0wMeta?.path ?? "/Hk/payforPage",
    meta: index5sQA2x4E0wMeta || {},
    alias: index5sQA2x4E0wMeta?.alias || [],
    redirect: index5sQA2x4E0wMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payforPage/index.vue").then(m => m.default || m)
  },
  {
    name: index5sQA2x4E0wMeta?.name ?? "payforPage___Cn",
    path: index5sQA2x4E0wMeta?.path ?? "/Cn/payforPage",
    meta: index5sQA2x4E0wMeta || {},
    alias: index5sQA2x4E0wMeta?.alias || [],
    redirect: index5sQA2x4E0wMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payforPage/index.vue").then(m => m.default || m)
  },
  {
    name: index5sQA2x4E0wMeta?.name ?? "payforPage___Id",
    path: index5sQA2x4E0wMeta?.path ?? "/Id/payforPage",
    meta: index5sQA2x4E0wMeta || {},
    alias: index5sQA2x4E0wMeta?.alias || [],
    redirect: index5sQA2x4E0wMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payforPage/index.vue").then(m => m.default || m)
  },
  {
    name: index5sQA2x4E0wMeta?.name ?? "payforPage___Ja",
    path: index5sQA2x4E0wMeta?.path ?? "/Ja/payforPage",
    meta: index5sQA2x4E0wMeta || {},
    alias: index5sQA2x4E0wMeta?.alias || [],
    redirect: index5sQA2x4E0wMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payforPage/index.vue").then(m => m.default || m)
  },
  {
    name: indexxMkMPQWVM4Meta?.name ?? "payments___En",
    path: indexxMkMPQWVM4Meta?.path ?? "/En/payments",
    meta: indexxMkMPQWVM4Meta || {},
    alias: indexxMkMPQWVM4Meta?.alias || [],
    redirect: indexxMkMPQWVM4Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: indexxMkMPQWVM4Meta?.name ?? "payments___Hk",
    path: indexxMkMPQWVM4Meta?.path ?? "/Hk/payments",
    meta: indexxMkMPQWVM4Meta || {},
    alias: indexxMkMPQWVM4Meta?.alias || [],
    redirect: indexxMkMPQWVM4Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: indexxMkMPQWVM4Meta?.name ?? "payments___Cn",
    path: indexxMkMPQWVM4Meta?.path ?? "/Cn/payments",
    meta: indexxMkMPQWVM4Meta || {},
    alias: indexxMkMPQWVM4Meta?.alias || [],
    redirect: indexxMkMPQWVM4Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: indexxMkMPQWVM4Meta?.name ?? "payments___Id",
    path: indexxMkMPQWVM4Meta?.path ?? "/Id/payments",
    meta: indexxMkMPQWVM4Meta || {},
    alias: indexxMkMPQWVM4Meta?.alias || [],
    redirect: indexxMkMPQWVM4Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: indexxMkMPQWVM4Meta?.name ?? "payments___Ja",
    path: indexxMkMPQWVM4Meta?.path ?? "/Ja/payments",
    meta: indexxMkMPQWVM4Meta || {},
    alias: indexxMkMPQWVM4Meta?.alias || [],
    redirect: indexxMkMPQWVM4Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_938gu28suH50Meta?.name ?? "receiptPage-id___En",
    path: _91id_938gu28suH50Meta?.path ?? "/En/receiptPage/:id()",
    meta: _91id_938gu28suH50Meta || {},
    alias: _91id_938gu28suH50Meta?.alias || [],
    redirect: _91id_938gu28suH50Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/receiptPage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_938gu28suH50Meta?.name ?? "receiptPage-id___Hk",
    path: _91id_938gu28suH50Meta?.path ?? "/Hk/receiptPage/:id()",
    meta: _91id_938gu28suH50Meta || {},
    alias: _91id_938gu28suH50Meta?.alias || [],
    redirect: _91id_938gu28suH50Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/receiptPage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_938gu28suH50Meta?.name ?? "receiptPage-id___Cn",
    path: _91id_938gu28suH50Meta?.path ?? "/Cn/receiptPage/:id()",
    meta: _91id_938gu28suH50Meta || {},
    alias: _91id_938gu28suH50Meta?.alias || [],
    redirect: _91id_938gu28suH50Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/receiptPage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_938gu28suH50Meta?.name ?? "receiptPage-id___Id",
    path: _91id_938gu28suH50Meta?.path ?? "/Id/receiptPage/:id()",
    meta: _91id_938gu28suH50Meta || {},
    alias: _91id_938gu28suH50Meta?.alias || [],
    redirect: _91id_938gu28suH50Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/receiptPage/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_938gu28suH50Meta?.name ?? "receiptPage-id___Ja",
    path: _91id_938gu28suH50Meta?.path ?? "/Ja/receiptPage/:id()",
    meta: _91id_938gu28suH50Meta || {},
    alias: _91id_938gu28suH50Meta?.alias || [],
    redirect: _91id_938gu28suH50Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/receiptPage/[id].vue").then(m => m.default || m)
  },
  {
    name: indexWQpFMaQ6FeMeta?.name ?? "searchLoading___En",
    path: indexWQpFMaQ6FeMeta?.path ?? "/En/searchLoading",
    meta: indexWQpFMaQ6FeMeta || {},
    alias: indexWQpFMaQ6FeMeta?.alias || [],
    redirect: indexWQpFMaQ6FeMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/searchLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexWQpFMaQ6FeMeta?.name ?? "searchLoading___Hk",
    path: indexWQpFMaQ6FeMeta?.path ?? "/Hk/searchLoading",
    meta: indexWQpFMaQ6FeMeta || {},
    alias: indexWQpFMaQ6FeMeta?.alias || [],
    redirect: indexWQpFMaQ6FeMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/searchLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexWQpFMaQ6FeMeta?.name ?? "searchLoading___Cn",
    path: indexWQpFMaQ6FeMeta?.path ?? "/Cn/searchLoading",
    meta: indexWQpFMaQ6FeMeta || {},
    alias: indexWQpFMaQ6FeMeta?.alias || [],
    redirect: indexWQpFMaQ6FeMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/searchLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexWQpFMaQ6FeMeta?.name ?? "searchLoading___Id",
    path: indexWQpFMaQ6FeMeta?.path ?? "/Id/searchLoading",
    meta: indexWQpFMaQ6FeMeta || {},
    alias: indexWQpFMaQ6FeMeta?.alias || [],
    redirect: indexWQpFMaQ6FeMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/searchLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexWQpFMaQ6FeMeta?.name ?? "searchLoading___Ja",
    path: indexWQpFMaQ6FeMeta?.path ?? "/Ja/searchLoading",
    meta: indexWQpFMaQ6FeMeta || {},
    alias: indexWQpFMaQ6FeMeta?.alias || [],
    redirect: indexWQpFMaQ6FeMeta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/searchLoading/index.vue").then(m => m.default || m)
  },
  {
    name: indexyk1AWCZTP7Meta?.name ?? "skeleton___En",
    path: indexyk1AWCZTP7Meta?.path ?? "/En/skeleton",
    meta: indexyk1AWCZTP7Meta || {},
    alias: indexyk1AWCZTP7Meta?.alias || [],
    redirect: indexyk1AWCZTP7Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/skeleton/index.vue").then(m => m.default || m)
  },
  {
    name: indexyk1AWCZTP7Meta?.name ?? "skeleton___Hk",
    path: indexyk1AWCZTP7Meta?.path ?? "/Hk/skeleton",
    meta: indexyk1AWCZTP7Meta || {},
    alias: indexyk1AWCZTP7Meta?.alias || [],
    redirect: indexyk1AWCZTP7Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/skeleton/index.vue").then(m => m.default || m)
  },
  {
    name: indexyk1AWCZTP7Meta?.name ?? "skeleton___Cn",
    path: indexyk1AWCZTP7Meta?.path ?? "/Cn/skeleton",
    meta: indexyk1AWCZTP7Meta || {},
    alias: indexyk1AWCZTP7Meta?.alias || [],
    redirect: indexyk1AWCZTP7Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/skeleton/index.vue").then(m => m.default || m)
  },
  {
    name: indexyk1AWCZTP7Meta?.name ?? "skeleton___Id",
    path: indexyk1AWCZTP7Meta?.path ?? "/Id/skeleton",
    meta: indexyk1AWCZTP7Meta || {},
    alias: indexyk1AWCZTP7Meta?.alias || [],
    redirect: indexyk1AWCZTP7Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/skeleton/index.vue").then(m => m.default || m)
  },
  {
    name: indexyk1AWCZTP7Meta?.name ?? "skeleton___Ja",
    path: indexyk1AWCZTP7Meta?.path ?? "/Ja/skeleton",
    meta: indexyk1AWCZTP7Meta || {},
    alias: indexyk1AWCZTP7Meta?.alias || [],
    redirect: indexyk1AWCZTP7Meta?.redirect || undefined,
    component: () => import("/Users/axin/Documents/qbworkfile/nuxt-front-web/src/pages/skeleton/index.vue").then(m => m.default || m)
  }
]